export const plainTextToHtml = (textValue = '') => {
    if (!textValue) return '';
    return textValue
        .split('\n')
        .map(line => `<p>${line || '<br />'}</p>`)
        .join('');
};

export const htmlToPlainText = (htmlValue = '') => {
    if (!htmlValue) return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlValue, 'text/html');
    const blockTags = new Set(['DIV', 'P', 'LI', 'TR', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'TABLE']);
    let text = '';

    const walk = (node) => {
        if (!node) return;
        if (node.nodeType === Node.TEXT_NODE) {
            text += node.nodeValue || '';
            return;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        const tagName = node.tagName;
        if (tagName === 'BR') {
            text += '\n';
            return;
        }

        const isBlock = blockTags.has(tagName);
        if (isBlock && text && !text.endsWith('\n')) {
            text += '\n';
        }

        Array.from(node.childNodes).forEach(walk);

        if (isBlock && !text.endsWith('\n')) {
            text += '\n';
        }
    };

    Array.from(doc.body?.childNodes || []).forEach(walk);
    return text
        .replace(/\u00a0/g, ' ')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n[ \t]+/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();
};
